import { React } from 'react';

export function StatusPanel(props) {
  return (
    <div className={ props.formStatus.error ? "status-panel status-panel-error" : "status-panel" }>
    	<div>
			<p>{props.formStatus.message}</p>
		</div>
    </div>
  );
}
